import { formatChartScoreDisplay } from "@patient-watch/charts";
import { cn } from "@/lib/utils";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface NumberEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: number | null;
    unit?: string;
    maxScore?: number | null;
}

export function NumberEntryValue({
    value,
    inputLabel,
    unit,
    maxScore,
    size,
    className,
    ...props
}: NumberEntryValueProps) {
    const parsedNumberValue = value !== null && value !== undefined ? Number(value) : null;
    const displayValue = parsedNumberValue !== null ? formatChartScoreDisplay(parsedNumberValue, "", maxScore) : "None";

    return (
        <BaseEntryValue inputLabel={inputLabel} size={size} className={className} {...props}>
            <div className="flex items-center bg-white/80 px-3 py-1 border border-slate-200 rounded-md w-fit">
                <span
                    className={cn(
                        "font-medium text-slate-900 dark:text-slate-200",
                        size === "sm" ? "text-sm" : size === "lg" ? "text-xl" : "text-md"
                    )}
                >
                    {displayValue}
                </span>
                {parsedNumberValue !== null && unit && maxScore == null && (
                    <span
                        className={cn(
                            "ml-1 text-slate-500 dark:text-slate-400",
                            size === "sm" ? "text-xs" : size === "lg" ? "text-sm" : "text-sm"
                        )}
                    >
                        {unit}
                    </span>
                )}
            </div>
        </BaseEntryValue>
    );
}
